import styled from 'styled-components';
import { mediaQuery } from '@design-system/Breakpoints/Breakpoints';

export const Container = styled.div`
  background: #fafafa;
  height: 90vh;
  display: grid;
  place-items: center;
  padding: 24px;
`;

export const Card = styled.div`
  background: #fff;
  border-radius: 4px;
  width: 100%;
  display: grid;
  place-items: center;
  padding-top: 50px;
  padding-bottom: 50px;
  padding-left: 16px;
  padding-right: 16px;

  ${mediaQuery.desktop`
  background: #fff;
  border-radius: 4px;
  width: 625px;
  display: grid;
  place-items: center;
  padding-top: 50px;
  padding-bottom: 50px;
  padding-left: 153px;
  padding-right: 153px;
  `}

  .image {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
  }

  .title {
    color: #333333;
    font-size: 18px;
    font-weight: 700;
    margin: 0;
    text-align: center;
  }

  .sub_title {
    margin-top: 10px;
    font-size: 14px;
    font-weight: 500;
    color: #4f4f4f;
    text-align: center;
  }

  .email {
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    text-align: center;
  }

  .order_no {
    text-align: center;
    color: #4f4f4f;
    font-size: 14px;
    margin: 0;
    font-weight: 500;
  }

  .transaction {
    text-align: center;
    color: #549a9a;
    font-size: 16px;
    font-weight: 700;
    margin: 0;
    margin-top: 5px;
  }

  .link {
    text-align: center;
    color: #549a9a;
    font-size: 12px;
    font-weight: 600;
    border-bottom: 0.5px solid #549a9a;
    display: inline-block;
    margin-top: 24px;
  }
`;

export const OrderSummary = styled.div`
  .title {
    color: #333333;
    font-size: 16px;
    font-weight: 700;
    padding: 13px;
    text-align: left;
  }

  .product {
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
    padding-top: 12px;
    padding-bottom: 18px;
    padding-left: 13px;
    padding-right: 12px;
    margin-bottom: 24px;
  }

  .product_container {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;

    img {
      width: 50px;
      height: 50px;
      border-radius: 5px;
    }

    .other_box {
      width: 50px;
      height: 50px;
      display: grid;
      place-items: center;
      border-radius: 2px;
      border: 1px solid #e0e0e0;
      color: #4f4f4f;
      font-size: 16px;
      font-weight: 700;
    }
  }
`;

export const Summary = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;

  .left {
    color: #333333;
    font-szie: 16px;
    font-weight: 700;
  }

  .right {
    color: #549a9a;
    font-szie: 16px;
    font-weight: 700;
  }
`;
